import { useLocation } from 'react-router-dom';

import MergesPanel from '../../features/audit/layouts/merges';
import DeletionsPanel from '../../features/audit/layouts/deletions';

// TSS vite/01 §"Pages are thin". Sección Auditoría (acciones administrativas sensibles):
//   /admin/audit/merges         → unificar duplicados
//   /admin/audit/eliminaciones  → borrado en cascada de OPU
export default function AuditPage() {
    const { pathname } = useLocation();
    if (pathname.endsWith('/eliminaciones')) return <DeletionsPanel />;
    return <MergesPanel />;
}
